import axios, { AxiosError } from 'axios';
import { apiClient, apiClientDowloadXL } from './apiClient';
import { Ontotis } from '../types';
import { ApiError } from '../error/error';




//Λιστα όλων των οντοτητων
export const getOntotisAllList = async () => {
  try {
    const response = await apiClient.get(`api/admin/ontotis`);
  


    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to all ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};


//Πληροφορίες για μία Οντοτητα
export const getOntotisSingle = async (id: number) => {
  try {
    const response = await apiClient.get(`api/admin/ontotis/${id}`);
    
   
    
    return response.data;
  } catch (error) {
  if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};


//ADD Οντοτητας
export const addOntotis = async (data:any) => {
  try {
    const response = await apiClient.post(`api/admin/ontotis`, data );

  

    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to add ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  
  }
};

//UPDATE Οντοτητας
export const updateOntotis = async (id: number, data:any) => {
  try {
    const response = await apiClient.put(`api/admin/ontotis/${id}`, data );
   // console.log('fsdf=--', response);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to update ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};

//Delete Οντοτητας
export const deleteOntotis = async (id: number) => {
  try {
    const response = await apiClient.delete(`api/admin/ontotis/${id}`);

    return response.data;
  } catch (error) {
   //console.log('fsdf=--', error);
    if (axios.isAxiosError(error) && error.response) {
  
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || error.response.data.error || 'Failed to delete ontotis', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};

// Dowload Files
//https://contactusapi.agrotikianaptixi.gr/api/ontotis/8/export-persons
export const donwloadsStaffDetails = async (id: number)=> {
  try {
    const response = await apiClientDowloadXL.get(`api/ontotis/${id}/export-persons`, { responseType: 'blob' });
   // console.log(response);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;

    if (axiosError.response) {
      throw new ApiError(
        `Failed to fetch resource for ID ${id}`,
        axiosError.response.status
      );
    } else if (axiosError.request) {
      throw new ApiError(`No response received for ID ${id}`, 500); // Assume server/network error
    } else {
      throw new Error(`Unexpected error occurred: ${axiosError.message}`);
    }
  }
};